









































































































































































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';
import { objectToQuerystring } from '@/services/api';
import {page} from '@/services/api';
import {mapActions, mapGetters} from 'vuex';
import AboutApartmentRuleItem from '@/components/AboutApartmentRule/AboutApartmentRuleItem';
import {ValueView} from '@/components/ValueView';
import {Title} from '@/components/Title';
import {RentBlock} from '@/components/RentBlock';

@Component({
  name: 'Checkout',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  components: {
    AboutApartmentRuleItem, RentBlock,
    Title, VLazyImage, ValueView,
  },
  created() {
    page('catalog');
  },
  updated() {
    (this as any).updateLink();
  },
  mounted() {
    (this as any).updateLink();
    this.$gtm.trackEvent({
      eventCategory: 'rent_funnel',
      eventAction: 'click',
      eventLabel: 'booking_page',
      event: 'booking_page',
    });
  },
  beforeDestroy() {
    if (this.linkToCatalog) {
      this.linkToCatalog.removeEventListener('click', this.routToLink);
    }
  },
  data() {
    return {
      agree: true,
      agreeRules: true,
      tokenData: null,
      linkToCatalog: document.getElementById('foreign_catalog'),
      checkError: '',
    };
  },
  computed: {
    ...mapGetters('catalog', ['aboutApartmentData', 'checkoutTexts']),
    ...mapGetters('user', ['loggedUser']),
    ...mapGetters(['apartmentRules', 'searchingPanelState', 'actualSearchData']),
    mappedRules() {
      return this.apartmentRules.map((item) => {
        return {
          name: !!this.checkoutTexts ? this.checkoutTexts.rules_block[item] : '',
          value: this.aboutApartmentData[item],
        };
      });
    },

    linkToCatalogHref(): {} {
      const objForQuery = {...this.actualSearchData, ...{foreign_card: 'True'}};
      if (Array.isArray(this.actualSearchData.rooms)) {
        (objForQuery as any).rooms = this.actualSearchData.rooms.join();
      }
      return objForQuery;
    },
  },
  methods: {
    ...mapActions('catalog', ['fetchAboutApartment']),
    ...mapActions('profile', ['checkCard']),

    updateLink() {
      this.linkToCatalog = document.getElementById('foreign_catalog');
      if (this.linkToCatalog) {
        const { href } = this.$router.resolve({name: 'catalog', query: (this as any).linkToCatalogHref});
        (this.linkToCatalog as HTMLAnchorElement).href = href;
        this.linkToCatalog.addEventListener('click', this.routToLink);
      }
    },

    goToPayment() {
      if (this.agree && this.agreeRules) {
        this.checkCard(this.aboutApartmentData.id).then((response) => {
          if (response.status === 200) {
            this.$emit('setActualAmount', response.data);
            this.$emit('nextStep');
          } else if (response.status === 400 && response.data?.form) {
            this.tokenData = response.data.form;
            this.$nextTick(() => (this.$refs.submitForm as HTMLElement).click());
          } else {
            (this as any).checkError = response.data?.mobile_errors[0]?.messages[0];
          }
        });
      }
    },
    srcImg(photo) {
      return photo && `${photo[3600]}` || '';
    },

    srcImgPlaceholder(photo) {
      return photo && `${photo[400]}`;
    },

    srcSet(photo) {
      return photo && `${photo[400]} 400w, ${photo[400]} 800w,
      ${photo[400]} 1300w, ${photo[800]} 1900w, ${photo[3600]} 3600w`;
    },

    routToLink(e) {
      e.preventDefault();
      this.$router.push({name: 'catalog', query: (this as any).linkToCatalogHref});
    },
  },
})
export default class Checkout extends Vue {
}
